import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import Message from '../common/message/Message';
import Spacer from '../common/spacer/Spacer';
import {ProgressItem} from './ProgressItem';
import {ProgHead} from './ProgHead';
import {ProgText} from './ProgText';
import { PROGRESS } from '../../constants/ProgressStates';

const Step4Active = () => (
    <Fragment>
        <ProgText code="epic.esport.step4.content" />

        <ProgHead code="epic.esport.step4.verification.title" />
        <ProgText code="epic.esport.step4.verification.list" />
        <Spacer as="ul" bottom={16}>
            <Message as="li" code="epic.esport.step4.verification.item1" />
            <Message as="li" code="epic.esport.step4.verification.item2" />
            <Message as="li" code="epic.esport.step4.verification.item3" />
        </Spacer>

        <ProgHead code="epic.esport.step4.minor.title" />
        <ProgText code="epic.esport.step4.minor.content" />
    </Fragment>
);

const renderContent = (offlinePayment, status) => {
    if (offlinePayment) {
        if (status === PROGRESS.INCOMPLETE) {
            return <Message as="div" code="epic.esport.step4.direct.incomplete.content" />;
        }
        if (status === PROGRESS.ACTIVE) {
            return <Message as="div" code="epic.esport.step4.direct.content" />;
        }
    }

    if (status === PROGRESS.INCOMPLETE) {
        return <ProgText as={Spacer} code="epic.esport.step4.incomplete.content" />;
    }

    return <Step4Active />;
};

const mapStateToProps = (state) => ({
    messages: state.get('localization').get('messageProperties')
});

@connect(mapStateToProps)
export class Step4 extends React.Component {
    render() {
        const {
            offlinePayment,
            status,
            ...otherProps
        } = this.props;

        return (
            <ProgressItem
                step={4}
                status={status}
                title={offlinePayment
                    ? <Message fragment code="epic.esport.step4.direct.title" />
                    : <Message fragment code="epic.esport.step4.title" />
                }
                {...otherProps}
            >
                <Spacer top={16} bottom={16}>
                    {renderContent(offlinePayment, status)}
                </Spacer>
            </ProgressItem>
        );
    }
}

Step4.displayName = 'Step4';

Step4.propTypes = {
    status: PropTypes.oneOf(Object.values(PROGRESS)),
    offlinePayment: PropTypes.bool,
    messages: PropTypes.object
};
